import type { DebouncedFunc } from 'lodash-es';
import { debounce } from 'lodash-es';
import { useCallback, useEffect, useState } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useDebounce<T extends(...args: any[]) => any>(callback: T, wait: number): DebouncedFunc<T> {
  // needs to be the return value of debounce(...) instead of `() => debounce` to use the _same_ debounced function on every call
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(
    debounce(callback, wait),
    [callback],
  );
}

export function useDebouncedState<T>(value: T, wait: number): T {
  const [state, setState] = useState(value);

  const debouncedSetState = useDebounce(setState, wait);

  useEffect(() => debouncedSetState(value), [debouncedSetState, value]);

  return state;
}
